export default "__VITE_ASSET__52315a99__"